import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../common/hooks/hooks";
import { setUseBillingForShipping } from "../../checkoutSlice";
import { RootState } from "../../../../../app/store";

const UseBillingForShippingToggle: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const useBillingForShipping = useAppSelector(
    (state: RootState) => state.checkout.useBillingForShipping
  );

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setUseBillingForShipping(e.target.checked));
  };

  return (
    <div className="form-field checkbox-field">
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={useBillingForShipping}
          onChange={handleToggle}
        />
        <span className="checkbox-text">
          {t(
            "checkoutForm.fields.useSameAddress",
            "Use this address for shipping"
          )}
        </span>
      </label>
    </div>
  );
};

export default UseBillingForShippingToggle;
